let messagePrefix = '';
export const setMessagePrefix = (prefix: string): void => {
  messagePrefix = prefix;
};

// payload really is any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (type: string, payload: any = null, recipient: Window = window.parent): void => recipient.postMessage(
  {
    type: `${messagePrefix}${type}`,
    payload,
  },
  '*',
);
